/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { PendingTalentReferralDto } from "../types/pendingTalentReferralDto";

import type { ProblemDetails } from "../types/problemDetails";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * **Required Permission(s):** ORG_TALENT_REFERRAL_LIST
 */
export const getPendingTalentReferrals = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PendingTalentReferralDto[]>> => {
  return axios.default.get(`/api/talent-referrals/pending`, options);
};

export const getGetPendingTalentReferralsQueryKey = () => {
  return [`/api/talent-referrals/pending`] as const;
};

export const getGetPendingTalentReferralsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPendingTalentReferrals>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPendingTalentReferrals>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPendingTalentReferralsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPendingTalentReferrals>>
  > = ({ signal }) => getPendingTalentReferrals({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPendingTalentReferrals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPendingTalentReferralsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPendingTalentReferrals>>
>;
export type GetPendingTalentReferralsQueryError = AxiosError<void>;

export function useGetPendingTalentReferrals<
  TData = Awaited<ReturnType<typeof getPendingTalentReferrals>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPendingTalentReferrals>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPendingTalentReferralsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_TALENT_REFERRAL_INVITE
 */
export const sendTalentReferralInvite = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.post(
    `/api/talent-referrals/${id}/send-invite`,
    undefined,
    options,
  );
};

export const getSendTalentReferralInviteMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTalentReferralInvite>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendTalentReferralInvite>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["sendTalentReferralInvite"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendTalentReferralInvite>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return sendTalentReferralInvite(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendTalentReferralInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendTalentReferralInvite>>
>;

export type SendTalentReferralInviteMutationError =
  AxiosError<ProblemDetails | void>;

export const useSendTalentReferralInvite = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTalentReferralInvite>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendTalentReferralInvite>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getSendTalentReferralInviteMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_TALENT_REFERRAL_DENY
 */
export const denyTalentReferral = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.post(
    `/api/talent-referrals/${id}/deny`,
    undefined,
    options,
  );
};

export const getDenyTalentReferralMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof denyTalentReferral>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof denyTalentReferral>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["denyTalentReferral"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof denyTalentReferral>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return denyTalentReferral(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DenyTalentReferralMutationResult = NonNullable<
  Awaited<ReturnType<typeof denyTalentReferral>>
>;

export type DenyTalentReferralMutationError = AxiosError<ProblemDetails | void>;

export const useDenyTalentReferral = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof denyTalentReferral>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof denyTalentReferral>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDenyTalentReferralMutationOptions(options);

  return useMutation(mutationOptions);
};
